import { TweenMax, TimelineMax } from 'gsap';
import { ScrollMagicPluginGsap } from 'scrollmagic-plugin-gsap';
import dynamic from 'next/dynamic';
import css from './Mh200Pc.module.scss';
import MhA from './mhA';
import ScrollMagicFn from '@/utils/ScrollMagic';

const PageConPc = dynamic(() => import('@/components/productSmart/Mh200/indexDynamic'), {
    ssr: true,
});

export default function Mh200Pc({}: any) {
    if (typeof window !== 'undefined' && typeof ScrollMagic == 'undefined') {
        window.ScrollMagic = ScrollMagicFn();
        ScrollMagicPluginGsap(ScrollMagic, TweenMax, TimelineMax);
    }

    return (
        <div className={`Mh200Pc ${css.Mh200Pc}`}>
            <MhA />
            <PageConPc />
        </div>
    );
}
